import { absolutePath } from "./absolutePath";

export const communityMemberBulkInvitations = {
  create: () => absolutePath("community_member_bulk_invitations"),
  validateEmail: () =>
    absolutePath("community_member_bulk_invitations/validate_email"),
};
